<template>
  <div class="current-charging" id="current-charging">
    <span class="homepage-title">充电桩分布</span>
    <div class="chart-box">
      <div style="width:100%;height:100%;" id="charging-echarts2"></div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  props:["HEIGHT1"],
  data() {
    return {
      HEIGHT: "",
      width: "",
      list: [],
      data: [],
      type: [],
      total: 0,
    };
  },
  mounted() {
    // this.drawChart();
    let o = document.getElementById("current-charging");
    this.$nextTick(function() {

      if(this.$store.state.getChargerTypes!=""){
          this.getEchartData();
        }

      // this.getEchartData();
    });
  },
  destroyed(){
    window.onresize = null;
  },
  beforeDestroy(){
    clearInterval(this.timer);
  },
  methods: {
    getEchartData() {
      // let params = {
      //   uid: localStorage.getItem("uid"),
      //   token: localStorage.getItem("token"),
      //   action: "getChargerTypes"
      // };
      // this.$api({
      //   method: "post",
      //   url: "/api.php/Overview/Index",
      //   data: params,
      //   transformRequest: [
      //     data => {
      //       let ret = "";
      //       for (let it in data) {
      //         ret +=
      //           encodeURIComponent(it) +
      //           "=" +
      //           encodeURIComponent(data[it]) +
      //           "&";
      //       }
      //       return ret;
      //     }
      //   ]
      // })
      //   .then(su => {
        let su =this.$store.state.getChargerTypes
          if (su.data.code == 1) {
            this.list = su.data.list;
            // this.list =  [
            //   {model: "1", type: "AC", num: "3"},
            //   {model: "2", type: "AC", num: "3"},
            //   {model: "3", type: "AC", num: "5"},
            //   {model: "1", type: "DC", num: "10"},
            //   {model: "2", type: "DC", num: "15"},
            //   {model: "3", type: "DC", num: "5"},
            // ];
            if(this.list.length == 0){
              this.list = [
                {
                  model: "1", type: "AC", num: "0"
                }
              ];
            }

            for (let i in this.list) {
              // if (this.list[i].model == "1") {
              //   this.list[i].name = "7KW";
              // } else if (this.list[i].model == "2") {
              //   this.list[i].name = "30KW";
              // } else if (this.list[i].model == "3") {
              //   this.list[i].name = "60KW";
              // } else if (this.list[i].model == "4") {
              //   this.list[i].name = "40KW";
              // } else if (this.list[i].model == "5") {
              //   this.list[i].name = "42KW";
              // } else if (this.list[i].model == "6") {
              //   this.list[i].name = "80KW";
              // } else if (this.list[i].model == "7") {
              //   this.list[i].name = "84KW";
              // } else if (this.list[i].model == "8") {
              //   this.list[i].name = "90KW";
              // } else if (this.list[i].model == "9") {
              //   this.list[i].name = "120KW";
              // } else if (this.list[i].model == "10") {
              //   this.list[i].name = "240KW";
              // }
              if (this.list[i].type == "DC") {
                this.list[i].type = "直流";
              } else if (this.list[i].type == "AC") {
                this.list[i].type = "交流";
              }
              this.list[i].name = this.list[i].model_name + this.list[i].type;
              this.type.push({name:this.list[i].name,textStyle: {fontSize:"12px",}}); //图例
              this.data.push({
                value: this.list[i].num,
                name: this.list[i].name
              }); //数据
            }
            this.drawChart(this.data);
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            // this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        // })
        // .catch(err => {});
    },
    drawChart(data) {
      // console.log(this.type);
      this.total = 0;
      for (let i in this.list) {
        this.total = this.total + Number(this.list[i].num);
      }
      let echart = echarts.init(document.getElementById("charging-echarts2"));
      var option = {
        tooltip: {
          textStyle: {
            align: "left"
          }
        },
        color: ["#60C8FF", "#e9621e", "#E5DD00","#33b66a","#b28f19"],
        legend: {
          bottom: 8,
          left: "center",
          itemWidth: 10, // 图例图形宽度
          itemHeight: 10,
          itemGap:0,//图例之间距离
          textStyle: {
            color: "#FFFDFE",
          },
          icon: "circle", //图例形状设置
          data: this.type,
        },
        graphic: [
          //饼图中间数字和文字显示
          {
            type: "text",
            // left: "36%",
            // top: "120px",
            left: "center",
            top: "40%",
            z: 2,
            zlevel: 100,
            style: {
              text: "在线电桩数",
              fill: "#FFFFFD",
              font: "bold Microsoft YaHei",
              fontSize: 14
            }
          },
          {
            type: "text",
            // left: "45%",
            // bottom: "100px",
            left: "center",
            top: "50%",
            z: 2,
            zlevel: 100,
            style: {
              text: this.total,
              fill: "#5ec9ff",
              // font: "bold Microsoft YaHei",
              fontWeight: 700,
              fontSize: 26
            }
          }
        ],
        series: [
          {
            name: "充电桩数",
            type: "pie",
            radius: ["38%", "53%"],
            center: ['50%', '45%'],
            label: { //饼图线
              normal: {
                textStyle: {
                  // color: "#5FC7FE",
                  fontSize: 10
                },
                // position: 'outside',
                formatter: "{b}\n{per|{d}%}\n\n",
                borderWidth: 20,
                borderRadius: 4,
                padding: [0, -30],
                rich: {
                  a: {
                    fontSize: 10,
                    lineHeight: 20,
                    align: "center"
                  },
                  //                         hr: {
                  //                             width: '100%',
                  //                             height: 4,
                  //                             align:'center'
                  //                         },
                  per: {
                    align: "center",
                    fontSize: 10
                  }
                }
              },
            },
            data: data,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{b}  \n {c}" //标题换行，按照自己的格式进行配置
                },
                labelLine: {
                  show: true,
                  length:20,
                  length2:40,
                },
                borderWidth: 4, //每个扇形直接留有空隙
                borderColor: "#0C1E2A", //空隙颜色设置
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          },
        ]
      };
      echart.setOption(option);
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        setTimeout(function (){
          window.onresize = function () {
            echart.resize();
          }
        },0)
      }, 100);
    }
  }
};
</script>

<style scoped lang="scss">
.current-charging {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  .homepage-title {
    left: 11%;
    color: #fffffd;
  }
  .chart-box {
    width: 100%;
    height: 90%;
    position: absolute;
    bottom: 0;
    // padding-top: 10%;
  }
}
@media screen and (max-width: 1500px) {
  .current-charging {
    .homepage-title {
      font-size: 12px;
      top: 7px;
      // left: 17px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/displayScreen/currentChargingChart.vue